import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'ngx-top-header',
  templateUrl: './top-header.component.html',
  styleUrls: ['./top-header.component.scss']
})
export class TopHeaderComponent implements OnInit {
  headerType = "topHeader";
  constructor() { }

  ngOnInit(): void {
  }

}
